import axios from 'axios';
import React, { useState } from 'react'
import './newtodo.scss';
const NewTodo = ({settodos,setloading}) => {
  // const [loading, setloading] = useState(false)
    const [newTask, setnewTask] = useState("");
    const handleSubmit = async(e)=>{
      if(newTask === "") return alert("Task cannot be empty")
      e.preventDefault();
      setloading(true);
      try{
        const {data} = await axios.post("/api/todo/new",{todo:newTask},{withCredentials:true});
        settodos(prev=>[...prev,data.todo]);
        setloading(false);
        setnewTask("");
      }
      catch(err){
        setloading(false)
        console.log(err.response.data.msg)
      }
    }
  return (
      <form onSubmit={handleSubmit}>
    <div className='new-todo'>
        <input type="text" placeholder='Enter a new Task' value={newTask} onChange={e=>setnewTask(e.currentTarget.value)} />
        <button type='submit'>ADD TASK</button>
    </div>
      </form>
  )
}

export default NewTodo